export const setBasicDetails = (body) => ({
  type: "SET_BASIC",
  payload: body,
});
export const setACKNumber = (body) => ({
  type: "SET_ACK_NUMBER",
  payload: body,
});
export const setPersonalDetails = (body) => ({
  type: "SET_PERSONAL_DETAILS",
  payload: body,
});
export const setKycDetails = (body) => ({
  type: "SET_KYC_DATA",
  payload: body,
});
export const setKycTrackDetails = (body) => ({
  type: "SET_KYC_TRACK_DETAILS",
  payload: body,
});
export const setSchemeDetails = (body) => ({
  type: "SET_SCHEME_DETAILS",
  payload: body,
});
export const setFundDetails = (body) => ({
  type: "SET_FUND_DETAILS",
  payload: body,
});
export const setBankDetails = (body) => ({
  type: "SET_BANK_DETAILS",
  payload: body,
});
export const setNomineeDetails = (body) => ({
  type: "SET_NOMINEE_DETAILS",
  payload: body,
});
export const setAccountTypes = (body) => ({
  type: "SET_ACCOUNT_TYPE",
  payload: body,
});
export const setPennyDropTypes = (body) => ({
  type: "SET_PENNY_DROP_RESPONSE",
  payload: body,
});
export const setSummaryDetails = (body) => ({
  type: "SET_SUMMARY_DETAILS",
  payload: body,
});
export const setEKYCDetails = (body) => ({
  type: "SET_EKYC_DETAILS",
  payload: body,
});
export const setPOPbankDetails = (body) => ({
  type: "SET_POP_BANK_DETAILS",
  payload: body,
});
export const setCountriesListStateListDetails = (body) => ({
  type: "SET_COUNTRIES_DETAILS",
  payload: body,
});
export const setKYCBankDetails = (body) => ({
  type: "SET_KYC_BANK_DETAILS",
  payload: body,
});
export const setStatusBackToSummary = (body) => ({
  type: "SET_STATUS_BACK_TO_SUMMARY",
  payload: body,
});
export const setAadhaarDetails = (body) => ({
  type: "SET_AADHAAR_DETAILS",
  payload: body,
});
export const setAAADetails = (body) => ({
  type: "SET_AAA_DETAILS",
  payload: body,
});
export const setFatcaDetails = (body) => ({
  type: "SET_FATCA_DETAILS",
  payload: body,
});

export const setDistrict = (body) => ({
  type: "SET_DISTRICT",
  payload: body,
});

export const setSkipKyc = (body) => ({
  type: "SET_SKIP_KYC",
  payload: body,
});

export const setStatesAndCountries =
  ({ statesList, countriesList }) =>
  (dispacthContext) =>
    dispacthContext({
      type: "SET_BASIC",
      payload: {
        statesList,
        countriesList,
      },
    });

export const setOldAccountType = (accountType) => (dispacthContext) => {
  dispacthContext({
    type: "SET_BASIC",
    payload: {
      oldAccountType: accountType,
      isBackToSummary: true,
    },
  });
};

export const resetOldAccountType = (dispatchContext) => {
  dispatchContext({
    type: "SET_BASIC",
    payload: {
      oldAccountType: "",
      isBackToSummary: false,
    },
  });
};

export const setDocuementDetails = (payload) => (dispatchContext) => {
  dispatchContext({
    type: "SET_DOCUMENT_DETAILS",
    payload: {
      isPersisted: true,
      documents: payload,
    },
  });
};
